import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HomeSchemaOrg from '@/components/base/HomeSchemaOrg';
import HeroSection from './components/HeroSection';
import ValueSection from './components/ValueSection';
import StatsSection from './components/StatsSection';
import FeaturedArticles from './components/FeaturedArticles';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <HomeSchemaOrg />
      <Navbar />
      <main>
        <HeroSection />
        <ValueSection />
        <StatsSection />
        <FeaturedArticles />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}